// Layout actions
export const SET_WIDTH = "set_width";
export const PUSH_NOTIFICATION = "PUSH_NOTIFICATION";
export const PUSH_ALL_MESSAGES = "PUSH_ALL_MESSAGES";

// Actions related to authentication
export const AUTH_USER = "auth_user";
export const AUTH_MFA = "auth_mfa";
export const AUTH_NEW_PASSWORD_REQUIRED = "auth_new_password_required";
export const UNAUTH_USER = "unauth_user";
export const REGISTER_USER = "register_user";
export const REGISTER_USER_CONFIRM = "register_user_confirm";
export const REGISTER_MFA = "register_mfa";
export const REGISTER_USER_ERROR = "register_user_error";
export const FORGOT_PASSWORD = "forgot_password";
export const FORGOT_PASSWORD_CONFIRM = "forgot_password_confirm";
export const AUTH_ERROR = "auth_error";
export const AUTH_ERROR_CLEAR = "auth_error_clear";
export const IS_LOADING = "is_loading";
export const LOGIN_REGISTER_CONFIRMATION = "login_register_confirmation";
export const FETCH_SKILL = "fetch_skill";
export const FETCH_USER_CHAT_SKILL_HISTORY = "FETCH_USER_CHAT_SKILL_HISTORY";
export const SET_APP_TYPE = "SET_APP_TYPE";

// Chat
export const KEEP_SCROLL_POSITION = "KEEP_SCROLL_POSITION";
export const CURRENT_SCROLL_POSITION = "CURRENT_SCROLL_POSITION";
export const REFRESHING_COGNITO_USER_TOKENS = "REFRESHING_COGNITO_USER_TOKENS";
export const UPDATE_CHAT_OPEN_STATE = "UPDATE_CHAT_OPEN_STATE";
export const UPDATE_ALL_TIME_CHAT_USER_HISTORY = "UPDATE_ALL_TIME_CHAT_USER_HISTORY";
export const UPDATE_CHAT_SIZE = "UPDATE_CHAT_SIZE";
export const UPDATE_CHAT_POSITION = "UPDATE_CHAT_POSITION";
export const WELCOME_MESSAGE_SENT = "WELCOME_MESSAGE_SENT";
export const UPDATE_BUBBLE_RESPONSE = "UPDATE_BUBBLE_RESPONSE";
export const UPDATE_CHAT_BOUNDS = "UPDATE_CHAT_BOUNDS";
export const SHOW_CHATBOT = "SHOW_CHATBOT";

// Actions associated with Your own API
export const REQRES_FETCH_ALL_SUCCESS = "reqres_fetch_all_success";
export const REQRES_CREATE_SUCCESS = "reqres_create_success";
export const REQRES_ERROR = "reqres_error";
 
// Actions associated with Getting Started Wizard
export const WIZARD_GO_TO_CONNECTORS = "WIZARD_GO_TO_CONNECTORS";
export const WIZARD_GO_TO_NEW_CONNECTOR_FORM = "WIZARD_GO_TO_NEW_CONNECTOR_FORM";
export const WIZARD_CREATE_CONNECTOR = "WIZARD_CREATE_CONNECTOR";
export const WIZARD_UPDATE_PROFILE = "WIZARD_UPDATE_PROFILE";
export const WIZARD_CHOOSE_STEP = "WIZARD_CHOOSE_STEP";
export const GET_FEATURED_CONNECTORS = "GET_FEATURED_CONNECTORS";
export const TEST_CONNECTION = "TEST_CONNECTION";
export const CLEAR_TESTED_CONNECTION = "CLEAR_TESTED_CONNECTION";
export const CLEAR_FEATURED_CONNECTORS = "CLEAR_FEATURED_CONNECTORS";
export const CLEAR_CREATED_CONNECTION = "CLEAR_CREATED_CONNECTION";
export const WIZARD_GO_TO_FINAL_SCREEN = "WIZARD_GO_TO_FINAL_SCREEN";
export const CLEAR_ALL_WIZARD_STATE = "CLEAR_ALL_WIZARD_STATE";
export const WIZARD_SET_APP_TYPE = "WIZARD_SET_APP_TYPE";
export const WIZARD_CONNECT_COLLABORATION_TOOL = "WIZARD_CONNECT_COLLABORATION_TOOL";

// Actions associated with Connections
export const FETCH_CONNECTIONS = "FETCH_CONNECTIONS";
export const FETCH_CONNECTION = "FETCH_CONNECTION";
export const ENABLE_CONNECTION = "ENABLE_CONNECTION";
export const CREATE_CONNECTOR = "CREATE_CONNECTOR";
export const CREATE_PUBLIC_CONNECTOR = "CREATE_PUBLIC_CONNECTOR";
export const SET_CLICKED_CONNECTOR = "SET_CLICKED_CONNECTOR";
export const SET_LATEST_OAUTH_REDIRECT_LINK = "SET_LATEST_OAUTH_REDIRECT_LINK";
export const DISABLE_CONNECTOR = "DISABLE_CONNECTOR";
export const CLEAR_DISABLE_CONNECTOR_RESPONSE = "CLEAR_DISABLE_CONNECTOR_RESPONSE";
export const SET_PUBLIC_CHATBOT_SNIPPET_METADATA = "SET_PUBLIC_CHATBOT_SNIPPET_METADATA";

export const FETCH_ACTION_FIELDS = "FETCH_ACTION_FIELDS";
export const FETCH_ACTION_METAFIELDS = "FETCH_ACTION_METAFIELDS";
export const SAVE_ACTION_FIELDS = "SAVE_ACTION_FIELDS";


// Actions associated with Subscriptions
export const FETCH_SUBSCRIPTIONS = "FETCH_SUBSCRIPTIONS";
export const FETCH_SUBSCRIPTION_ESTIMATE = "FETCH_SUBSCRIPTION_ESTIMATE";
export const FETCH_SUBSCRIPTION_PAYMENT_INTENT = "FETCH_SUBSCRIPTION_PAYMENT_INTENT";
export const FETCH_SUBSCRIPTION_CREATE = "FETCH_SUBSCRIPTION_CREATE";
export const CLEAR_SUBSCRIPTION_CREATE = "CLEAR_SUBSCRIPTION_CREATE";
export const CLEAR_SUBSCRIPTION_ESTIMATE = "CLEAR_SUBSCRIPTION_ESTIMATE";
export const FETCH_SUBSCRIPTION_ADDONS = "FETCH_SUBSCRIPTION_ADDONS";
export const FETCH_LICENSES = "FETCH_LICENSES";
export const CLEAR_LICENSES_INFO = "CLEAR_LICENSES_INFO";

// Actions associated with Intents
export const FETCH_INTENTS = "FETCH_INTENTS";
export const CREATE_NEW_INTENT = "CREATE_NEW_INTENT";
export const BUILD_BOT = "BUILD_BOT";
export const BOT_STATUS = "BOT_STATUS";
export const DISABLE_INTENT = "DISABLE_INTENT";
export const CLEAR_DISABLE_INTENT_RESPONSE = "CLEAR_DISABLE_INTENT_RESPONSE";
export const RE_ENABLE_INTENT = "RE_ENABLE_INTENT";
export const CLEAR_RE_ENABLE_INTENT_RESPONSE = "CLEAR_RE_ENABLE_INTENT_RESPONSE";
export const TRIGGER_BUILD_BOT = "TRIGGER_BUILD_BOT";
export const TRIGGER_CHECK_BOT_STATUS = "TRIGGER_CHECK_BOT_STATUS";
export const UPDATE_FALLBACK_INTENT = "UPDATE_FALLBACK_INTENT";
export const CLEAR_UPDATE_FALLBACK_INTENT_RESPONSE = "CLEAR_UPDATE_FALLBACK_INTENT_RESPONSE";

// Actions associated with Profile screen
export const SETUP_TOTP = "SETUP_TOTP";
export const SETUP_SMS = "SETUP_SMS";
export const SETUP_MFA_SMS_ERROR = "SETUP_MFA_SMS_ERROR";
export const ENTER_VERIFICATION_MFA_CODE = "ENTER_VERIFICATION_MFA_CODE";
export const SETUP_MFA_ERROR = "SETUP_MFA_ERROR";
export const SETUP_MFA_INFO = "SETUP_MFA_INFO";
export const UPDATE_USER_ATTR = "UPDATE_USER_ATTR";
export const UPDATE_USER_ATTR_ERROR = "UPDATE_USER_ATTR";
export const REMOVE_MESSAGE = "REMOVE_MESSAGE";
export const RESEND_SUBMIT_SMS_VERIFICATION_CODE = "RESEND_SUBMIT_SMS_VERIFICATION_CODE";
export const FETCH_MY_CONTACTS = "FETCH_MY_CONTACTS";
export const REINVITE_USER = "REINVITE_USER";
export const CHANGE_USER_ROLE = "CHANGE_USER_ROLE";

// Dashboard
export const FETCH_FAILED = "FETCH_FAILED";
export const FETCH_WIDGET_DATA = "FETCH_WIDGET_DATA";
export const UPDATE_WIDGET_DATA = "UPDATE_WIDGET_DATA";
export const UPDATE_WIDGET_FROM_TO_DATES = "UPDATE_WIDGET_FROM_TO_DATES";

// Chatbot
export const FETCH_SETTINGS = "FETCH_SETTINGS";

// Custom slots
export const LIST_CUSTOM_SLOT_TYPES = "LIST_CUSTOM_SLOT_TYPES";
export const CREATE_NEW_CUSTOM_SLOT_TYPE = "CREATE_NEW_CUSTOM_SLOT_TYPE";
export const CLEAR_LIST_OF_CUSTOM_SLOT_TYPES = "CLEAR_LIST_OF_CUSTOM_SLOT_TYPES";
export const DELETE_CUSTOM_SLOT_TYPE = "DELETE_CUSTOM_SLOT_TYPE";
export const UPDATE_CUSTOM_SLOT_TYPE = "UPDATE_CUSTOM_SLOT_TYPE";
export const GENERATE_SKILL_BUILDER_CODE = "GENERATE_SKILL_BUILDER_CODE";
export const CLEAR_DELETE_CUSTOM_SLOT_TYPE_RESPONSE = "CLEAR_DELETE_CUSTOM_SLOT_TYPE_RESPONSE";
export const CLEAR_CREATED_CUSTOM_SLOT_TYPE_RESPONSE = "CLEAR_CREATED_CUSTOM_SLOT_TYPE_RESPONSE";
export const CLEAR_UPDATE_CUSTOM_SLOT_TYPE_RESPONSE = "CLEAR_UPDATE_CUSTOM_SLOT_TYPE_RESPONSE";
export const CLEAR_ALL_CUSTOM_SLOTS_STATE = "CLEAR_ALL_CUSTOM_SLOTS_STATE";

//UTTERANCE
export const FETCH_UTTERANCE_CLUSTER_DATA = "FETCH_UTTERANCE_CLUSTER_DATA";
export const FETCH_UTTERANCE_DATA = "FETCH_UTTERANCE_DATA";
export const FETCH_UTTERANCE_ENTITY_DATA = "FETCH_UTTERANCE_ENTITY_DATA";
export const FETCH_ANSWERS_FOR_UTTERANCE = "FETCH_ANSWERS_FOR_UTTERANCE";
export const SAVE_UTTERANCE_QUESTION_MATCH = "SAVE_UTTERANCE_QUESTION_MATCH";
export const SAVE_UTTERANCE_CLUSTER_QUESTION_MATCH = "SAVE_UTTERANCE_CLUSTER_QUESTION_MATCH";
export const FETCH_DROPDOWN_ENTITIES = "FETCH_DROPDOWN_ENTITIES";
export const FETCH_DROPDOWN_INTENTS = "FETCH_DROPDOWN_INTENTS";
export const SAVE_ENTITY_TYPE = "SAVE_ENTITY_TYPE";


//chatbot
export const FETCH_BUBBLES = "FETCH_BUBBLES";
export const UPDATE_BUBBLES = "UPDATE_BUBBLES";

// Suggestions
export const GET_SUGGESTIONS = "GET_SUGGESTIONS";
export const CLEAR_SUGGESTIONS = "CLEAR_SUGGESTIONS";

// FAQ CMS
export const GET_QUESTIONS_TO_REVIEW = "GET_QUESTIONS_TO_REVIEW";
export const GET_QUESTIONS_BY_USER = "GET_QUESTIONS_BY_USER";
export const ACCEPT_QUESTION = "ACCEPT_QUESTION";
export const REJECT_QUESTION = "REJECT_QUESTION";
export const CLEAR_FAQ_CMS_STATE = "CLEAR_FAQ_CMS_STATE";
export const SUBMIT_NEW_QUESTION = "SUBMIT_NEW_QUESTION";
export const UPLOAD_FAQ_CMS_IMAGE = "UPLOAD_FAQ_CMS_IMAGE";
export const GET_SUBJECT_AREAS = "GET_SUBJECT_AREAS";
export const MARK_SUBMITTED_FAQ_FOR_DELETION = "MARK_SUBMITTED_FAQ_FOR_DELETION";
export const DELETE_FAQ = "DELETE_FAQ";
export const REJECT_FAQ_DELETION_SUGGESTION = "REJECT_FAQ_DELETION_SUGGESTION";
export const GET_FAQ_CMS_SETTINGS = "GET_FAQ_CMS_SETTINGS";
export const SAVE_FAQ_CMS_SETTINGS = "SAVE_FAQ_CMS_SETTINGS";
